class DrawerMenu extends HTMLElement {
  constructor() {
    'use strict';
    super();

    this.el = this;
    this.mainLevel = this.el.querySelector('.drawer-menu__contents');
    this.init();
  }

  init() {

    // Auto close drawer in desktop if mega menu
    this._mqDesktop = window.matchMedia('(min-width: 1024px)');
    const onBpChange = () => this.autoCloseForMegaDesktop();
    if (this._mqDesktop.addEventListener) this._mqDesktop.addEventListener('change', onBpChange);
    this.autoCloseForMegaDesktop();

    // These toggle submenu panel
    this.firstLevelItemsWithChildren = this.el.querySelectorAll(
      '.drawer-menu__item__input',
    );
    this.firstLevelItemsWithChildren.forEach((input) => {
      input.addEventListener('change', this.toggleMenuItem.bind(this));
    });

    // Handle submenu item toggling
    this.submenuItemsWithChildren = this.el.querySelectorAll(
      '.drawer-submenu__item__input'
    );
    this.submenuItemsWithChildren.forEach((input) => {
      input.addEventListener('change', this.toggleSubmenuItem.bind(this));
    });

    // These handle closing of navigation
    this.closeButtons = this.el.querySelectorAll('[data-close]');
    this.closeButtons.forEach((btn) => {
      btn.addEventListener('click', this.closeAllItems.bind(this));
    });

    this.overlay = this.el.querySelector('[data-overlay]');
    this.overlay.addEventListener('click', this.closeAllItems.bind(this));

    // These handle going back to previous panel
    this.secondLevelBackButtons = this.el.querySelectorAll(
      '[data-drawer-submenu-close], [data-drawer-subsubmenu-close]'
    );
    this.secondLevelBackButtons.forEach((button) => {
      button.addEventListener('click', this.toggleSubPanel.bind(this));
    });

    // Handle opening of specific subitem from anywhere in the theme
    this.subitemOpeners = document.querySelectorAll(
      '[data-drawer-submenu-open]',
    );
    this.subitemOpeners.forEach((button) => {
      button.addEventListener('click', this.toggleMenuItemFromTheme.bind(this));
    });
  }

  // Only simulate a user click on [data-close] when mega + desktop + open
  autoCloseForMegaDesktop() {
    if (!this.el.classList.contains('menu-mega')) return;
    if (!this._mqDesktop?.matches) return;
    if (!this._isDrawerOpen()) return;

    let closeBtn = this.el.querySelector('[data-close]');
    if (!closeBtn) return;

    closeBtn.click();
  }

  // Detect if anything is open
  _isDrawerOpen() {
    if (this.el.classList.contains('is-open') ||
        this.el.getAttribute('aria-hidden') === 'false') {
      return true;
    }
    
    return !!this.mainLevel?.querySelector('input:checked');
  }

  closeAllItems(event, skipEl) {
    const checkboxes = this.mainLevel.querySelectorAll('input:checked');
    checkboxes.forEach((checkbox) => {
      if (skipEl && checkbox === skipEl) {
        return;
      }
      checkbox.checked = false;
      const accordion = checkbox.closest('[data-accordion-item]');
      if (accordion) {
        accordion.classList.remove('is-open');
        if (screen.width <= 820) {
          const parent = accordion.closest('.drawer-menu__contents');
          parent.classList.remove('pull-left');
        }
      }
    });

    if (!skipEl) {
      this.mainLevel.classList.remove('has-open-submenu');
    }
  }

  toggleMenuItem(scope) {
    const input = scope.currentTarget || scope;
    if (!input) return;

    this.closeAllItems(scope, input);

    const accordion = input.closest('[data-accordion-item]');
    if (!accordion) {
      return;
    }
    if (screen.width <= 820) {
      const parent = accordion.closest('.drawer-menu__contents');
      parent.classList.toggle('pull-left');
    }

    accordion.classList.toggle('is-open');
    if (accordion.classList.contains('is-open')) {
      this.mainLevel.classList.add('has-open-submenu');
    } else {
      this.mainLevel.classList.remove('has-open-submenu');
    }
  }

  toggleMenuItemFromTheme(scope) {
    let target = false;
    const button = scope.currentTarget || scope;
    const url = button.getAttribute('data-drawer-submenu-open');

    for (const input of this.firstLevelItemsWithChildren) {
      if (input.getAttribute('data-href') === url) {
        target = input;
        break;
      }
    }

    if (!target) return;

    Woolman.ModalsAndDrawers.showModalOrDrawer(this.el.getAttribute('id'));

    const animationFinished = () => {
      this.el.removeEventListener('transitionend', animationFinished);

      const evt = new Event('change');
      target.checked = true;
      target.dispatchEvent(evt);
    };
    this.el.addEventListener('transitionend', animationFinished);
  }

  toggleSubPanel(event) {
    const button = event.currentTarget;
    const targetSelector = button.getAttribute('data-drawer-submenu-close');
    if (!targetSelector) return;
  
    // Find the closest "is-open" item within the submenu and remove "is-open"
    const submenuItem = button.closest('.drawer-submenu__item');
    if (submenuItem) {
      submenuItem.classList.remove('is-open');
    }
  
    // Optionally focus the parent input or element (if required)
    const input = document.getElementById(targetSelector);
    if (input) {
      input.focus();
    }
  }

  toggleSubPanel(event) {
    // Prevent closing all items, we only want to close the current panel
    const button = event.currentTarget;
    const targetSelector = button.getAttribute('data-drawer-submenu-close');
    if (!targetSelector) {
      return;
    }

    const input = document.getElementById(targetSelector);
    if (!input) {
      return;
    }

    input.checked = false;

    // Remove the 'is-open' class from the closest 'data-accordion-item'
    const accordion = input.closest('[data-accordion-item]');
    if (accordion) {
      accordion.classList.remove('is-open');
      if (screen.width <= 820) {
        const parent = accordion.closest('.drawer-menu__contents');
        parent.classList.remove('pull-left');
      }
    }

    // Check if any other panels are still open; if not, remove 'has-open-submenu'
    const checkboxes = this.mainLevel.querySelectorAll('input:checked');
    if (checkboxes.length === 0) {
      this.mainLevel.classList.remove('has-open-submenu');
    }

    input.focus();
}

  toggleSubmenuItem(event) {
    const input = event.currentTarget;
    const submenuItem = input.closest('.drawer-submenu__item');
    const parentMenuItem = submenuItem.closest('.drawer-menu__item');

    // Toggle 'is-open' for the submenu item and parent
    submenuItem.classList.toggle('is-open', input.checked);
    parentMenuItem.classList.toggle('is-open', input.checked);
  }
}

if (customElements.get('drawer-menu') === undefined) {
  customElements.define('drawer-menu', DrawerMenu);
}
